import { isControlFieldTag } from './marcControlFields';
/** Control fields (00X) — neutral gray, technical metadata. */
export var CONTROL_FIELD_COLORS = {
    dark: '#6b7280', light: '#f9fafb', border: '#d1d5db', text: '#4b5563',
};
/**
 * Rainbow palette for MARC data field groups (0xx–9xx).
 * Adjacent groups always have clearly different hues.
 */
export var MARC_COLORS = {
    0: { dark: '#475569', light: '#f8fafc', border: '#cbd5e1', text: '#334155' }, // slate — 0xx data fields
    1: { dark: '#be123c', light: '#fff1f2', border: '#fecdd3', text: '#881337' }, // rose — main heading
    2: { dark: '#c2410c', light: '#fff7ed', border: '#fed7aa', text: '#7c2d12' }, // orange
    3: { dark: '#a16207', light: '#fefce8', border: '#fde68a', text: '#713f12' }, // amber
    4: { dark: '#4d7c0f', light: '#f7fee7', border: '#bef264', text: '#365314' }, // lime
    5: { dark: '#047857', light: '#ecfdf5', border: '#a7f3d0', text: '#064e3b' }, // emerald
    6: { dark: '#0e7490', light: '#ecfeff', border: '#a5f3fc', text: '#155e75' }, // cyan
    7: { dark: '#1d4ed8', light: '#eff6ff', border: '#bfdbfe', text: '#1e3a8a' }, // blue
    8: { dark: '#7c3aed', light: '#f5f3ff', border: '#ddd6fe', text: '#4c1d95' }, // violet
    9: { dark: '#a21caf', light: '#fdf4ff', border: '#f0abfc', text: '#701a75' }, // fuchsia
};
/** The colors a MARC field tag prints in — control fields neutral, 0xx–9xx by group. */
export var getMarcColors = function (tag) {
    if (isControlFieldTag(tag))
        return CONTROL_FIELD_COLORS;
    var group = parseInt(tag.charAt(0), 10);
    return MARC_COLORS[Number.isNaN(group) ? 0 : group];
};
